import type React from "react";
import { ReactComponent as Svg } from "./assets/clear.svg";
import * as styles from "./Icon.module.scss";

type ClearStakeProps = React.SVGProps<SVGSVGElement>;

export const ClearStake = ({ className, ...props }: ClearStakeProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
